import { render, staticRenderFns } from "./ImprecoesLayout.vue?vue&type=template&id=aea65598&"
import script from "./ImprecoesLayout.vue?vue&type=script&lang=js&"
export * from "./ImprecoesLayout.vue?vue&type=script&lang=js&"
import style0 from "./ImprecoesLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports